import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroApiPaths } from 'Feature/Khodro/ShakhsSales/ApiPaths/KhodroApiPaths';
import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';

export const getAllHarfHayePelak = createAsyncThunk('HarfHayePelak/GetAll', async (query: object) => {
  return await KhodroHttpGetService({
    url: `${KhodroApiPaths.HarfPelak.GetAllHarfHayePelak}`,
    params: query,
  });
});
